"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAmountPropertySelector = void 0;
var amount_property_selector_1 = require("./amount-property-selector");
Object.defineProperty(exports, "createAmountPropertySelector", { enumerable: true, get: function () { return amount_property_selector_1.createAmountPropertySelector; } });
//# sourceMappingURL=index.js.map